var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"appointment-btn",on:{"click":_setup.handleAppointment}},[_c('span',[_vm._v(_vm._s(_setup.getModuleName('appointment')))])]),_c(_setup.CDialogSurvey,{attrs:{"visible":_setup.visibleSurvey},on:{"update:visible":function($event){_setup.visibleSurvey=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }